export class VerificationMethodModel {
    type: string;
    method: string;
    identity: string;
    constructor(type?: string, method?: string, identity?: string) {
        this.type = type;
        this.method = method;
        this.identity = identity;
    }
}

export interface OTPRequest {
    token: string;
    lang: string;
    state?: string;
    methods: VerificationMethodModel;
    purpose: string;
}

export class OTPPurpose {
    public static readonly LOGIN = 'login';
    public static readonly SET_PIN = 'set_pin';
    public static readonly SET_PHONE = 'set_phone';
}

export interface RequestOTPResponse {
    referenceCode: string;
    methods: VerificationMethodModel;
}

export interface VerifyOTPRequest {
    token: string;
    state?: string;
    referenceCode: string;
    otp: string;
}

export interface VerifyOTPResponse {
    verifiedToken: string;
  }


// WEBPACK FOOTER //
// ./src/app/model/otp/otp.model.ts